import axios from "@/axios";
import saver from "file-saver";
import store from "@/store/index";
/**
 * 공통 파일 다운로드
 * @param {string} dir  - 파일 경로
 * @param {string} name - 파일명
 */
export default {
    async downloadFile(url, dir, name) {
        try {
            store.commit("loading/SHOW_LOADING");
            const response = await axios({
                method: "POST",
                url,
                responseType: "blob",
                headers: { "Content-Type": "application/json" },
                data: { dir, name },
            });

            if (!response || response.data.size === 0) {
                alert("해당 경로에 파일이 존재하지 않습니다.");
                return;
            }

            const blob = new Blob([response.data], { type: "application/octet-stream" });
            saver.saveAs(blob, name);
        } catch (err) {
            console.error(err);
            alert("파일 다운로드 중 오류가 발생했습니다.");
        } finally {
            store.commit("loading/HIDE_LOADING");
        }
    },
};
